import type { StyledProps } from '@lokalise/ui/styled';

import type { Theme } from '../types';

// Didn't work with `Record<>` for some reason so used `object`.
type EmptyRecord = object;
// Since we're extending this type, `any` isn't a big deal. We're just saying that return type can be anything
// and we'll just pass the type along.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Callback<Props extends EmptyRecord> = (theme: Theme, props: Props) => any;

export interface FromTheme<Props extends EmptyRecord = EmptyRecord> {
    <P extends Props, CB extends Callback<P>>(callback: CB): ({ theme, ...props }: StyledProps<P>) => ReturnType<CB>;
}

const fromTheme: FromTheme =
    (callback) =>
    ({ theme, ...props }) =>
        // Couldn't get `props` working without `any` here. But it's not a big deal since real type is inferred from
        // the interface above anyway and this `any` is irrelevant
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        callback(theme, props as any);

export default fromTheme;
